import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import _isString from "lodash/isString";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from 'react';
import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import Box from "../Box";
import ContextualLayer from "../Layer/ContextualLayer";
import Icon from "../Icon";
import { AlignTarget } from "../Align";
import Interactive from "../Interactive";
import Text from "../Text/Text";
var badgeColors = {
  gray: {
    textColor: 'gray600',
    iconColor: 'gray500',
    backgroundColor: 'gray100'
  },
  blue: {
    textColor: 'blue600',
    iconColor: 'blue500',
    backgroundColor: 'blue100'
  },
  cyan: {
    textColor: 'cyan600',
    iconColor: 'cyan500',
    backgroundColor: 'cyan100'
  },
  green: {
    textColor: 'green600',
    iconColor: 'green500',
    backgroundColor: 'green100'
  },
  yellow: {
    textColor: 'yellow600',
    iconColor: 'yellow500',
    backgroundColor: 'yellow100'
  },
  red: {
    textColor: 'red600',
    iconColor: 'red500',
    backgroundColor: 'red100'
  }
};

var InnerBadge = /*#__PURE__*/function (_React$Component) {
  _inherits(InnerBadge, _React$Component);

  var _super = _createSuper(InnerBadge);

  function InnerBadge() {
    _classCallCheck(this, InnerBadge);

    return _super.apply(this, arguments);
  }

  _createClass(InnerBadge, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          collapsed = _this$props.collapsed,
          collapseDirection = _this$props.collapseDirection,
          color = _this$props.color,
          label = _this$props.label,
          icon = _this$props.icon,
          iconPosition = _this$props.iconPosition,
          variant = _this$props.variant,
          badgeProps = _objectWithoutProperties(_this$props, ["className", "collapsed", "collapseDirection", "color", "label", "icon", "iconPosition", "variant"]);

      var labelLineHeight = 16;
      var labelSize = 12;
      var _badgeColors$color = badgeColors[color],
          textColor = _badgeColors$color.textColor,
          iconColor = _badgeColors$color.iconColor,
          backgroundColor = _badgeColors$color.backgroundColor;
      var classes = classNames('Badge', {
        'Badge--variant--status': variant === 'status',
        'Badge--variant--tag': variant === 'tag'
      }, className);
      var labelClasses = classNames('Badge-text', {
        'Badge-text--collapsed': collapsed
      });
      var iconPadding = 0;

      if (!collapsed) {
        if (iconPosition === 'left' || collapseDirection === 'right') {
          iconPadding = {
            right: 4
          };
        } else if (iconPosition !== 'left' || collapseDirection !== 'right') {
          iconPadding = {
            left: 4
          };
        }
      }

      return /*#__PURE__*/React.createElement(AlignTarget, _extends({}, badgeProps, {
        strategy: "x-center",
        size: labelSize,
        lineHeight: labelLineHeight
      }), function (alignProps) {
        return (
          /*#__PURE__*/
          // $FlowFixMe - go/flowfixme122
          React.createElement(Box, _extends({
            className: classes,
            flex: {
              alignItems: 'center',
              display: 'inline-flex',
              direction: iconPosition === 'left' || collapseDirection === 'right' ? 'row-reverse' : 'row'
            },
            background: backgroundColor,
            "aria-label": _isString(label) ? label : null
          }, badgeProps, alignProps), label && /*#__PURE__*/React.createElement(Text, {
            className: labelClasses,
            color: textColor,
            lineHeight: labelLineHeight,
            size: labelSize,
            weight: "medium",
            wrap: false
          }, label), icon && /*#__PURE__*/React.createElement(Box, {
            className: "Badge-icon--container",
            padding: iconPadding
          }, /*#__PURE__*/React.createElement(Icon, {
            color: iconColor,
            icon: icon,
            size: 12
          })))
        );
      });
    }
  }]);

  return InnerBadge;
}(React.Component);

InnerBadge.defaultProps = {
  collapsed: false,
  color: 'gray',
  variant: 'status'
};

var BadgeHoverLayer = function BadgeHoverLayer(props) {
  var element = props.element,
      collapseDirection = props.collapseDirection,
      badgeProps = props.badgeProps,
      hovered = props.hovered;
  var overlayAnchor = collapseDirection === 'left' ? 'topright' : 'topleft';
  var badgeDirection = collapseDirection === 'left' ? 'row-reverse' : 'row';
  return element ? /*#__PURE__*/React.createElement(ContextualLayer, {
    context: {
      element: element
    },
    contained: true,
    contextMeetingPoint: overlayAnchor,
    layerMeetingPoint: overlayAnchor,
    pointerEvents: false
  }, /*#__PURE__*/React.createElement(Box, {
    flex: {
      direction: badgeDirection
    }
  }, /*#__PURE__*/React.createElement(InnerBadge, _extends({}, badgeProps, {
    collapsed: !hovered,
    collapseDirection: collapseDirection,
    className: classNames({
      'Badge--collapsed': !hovered
    }, badgeProps.className)
  })))) : null;
};

var CollapsedBadge = /*#__PURE__*/function (_React$Component2) {
  _inherits(CollapsedBadge, _React$Component2);

  var _super2 = _createSuper(CollapsedBadge);

  function CollapsedBadge() {
    var _this;

    _classCallCheck(this, CollapsedBadge);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super2.call.apply(_super2, [this].concat(args));
    _this.contextRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(CollapsedBadge, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.collapsed) {
        // Handles the case when contextRef isn't yet rendered.
        // We need contextRef to render ContextualLayer properly
        this.forceUpdate();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          collapseDirection = _this$props2.collapseDirection,
          label = _this$props2.label,
          otherProps = _objectWithoutProperties(_this$props2, ["collapseDirection", "label"]);

      return /*#__PURE__*/React.createElement(Box, {
        flex: true
      }, /*#__PURE__*/React.createElement(Interactive, null, function (_ref) {
        var mouse = _ref.mouse,
            focus = _ref.focus;
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
          className: "Badge-layer--container",
          ref: _this2.contextRef
        }, /*#__PURE__*/React.createElement(InnerBadge, _extends({}, otherProps, {
          label: label,
          className: classNames({
            'Badge--collapsed': mouse !== 'hover'
          }, otherProps.className)
        }))), /*#__PURE__*/React.createElement(CSSTransition, {
          in: mouse === 'hover',
          classNames: "Badge-layer",
          timeout: 50,
          unmountOnExit: true
        }, /*#__PURE__*/React.createElement(BadgeHoverLayer, {
          collapseDirection: collapseDirection,
          element: _this2.contextRef.current,
          hovered: mouse === 'hover',
          badgeProps: _this2.props
        })));
      }));
    }
  }]);

  return CollapsedBadge;
}(React.Component);

CollapsedBadge.defaultProps = {
  collapseDirection: 'left',
  collapsed: false
};

var Badge = /*#__PURE__*/function (_React$Component3) {
  _inherits(Badge, _React$Component3);

  var _super3 = _createSuper(Badge);

  function Badge() {
    _classCallCheck(this, Badge);

    return _super3.apply(this, arguments);
  }

  _createClass(Badge, [{
    key: "render",
    value: function render() {
      if (this.props.collapsed) {
        return /*#__PURE__*/React.createElement(CollapsedBadge, this.props);
      }

      return /*#__PURE__*/React.createElement(InnerBadge, this.props);
    }
  }]);

  return Badge;
}(React.Component);

Badge.defaultProps = {
  collapsed: false,
  color: 'gray',
  variant: 'status'
};
export default Badge;